
/**
 * å»é¢å§ådto
 */
export class TenantNameDto {
  /**
   * å»é¢id
   */
  tenantId: number;

  /**
   * å»é¢åå­
   */
  tenantName: string;
}
